module.exports = __webpack_public_path__ + "static/media/facebook-white.a260cbbb.svg";